import React from "react";
import AppStandartContentFieldItem from "./app_standard_content_field_item";
import { Col, Collapse, Row } from "antd";
import "./app_quotation_detail_card.css";
import Config from "../../../Config";
import LanguageBloc from "../../../bloc/language_bloc";
// import Labels from "../../constant/labels";
import UtilBloc from "../../../bloc/util_bloc";
import { ReactComponent as ArrowDownIcon } from "../../../ArrowDownIcon.svg";
import { ReactComponent as ChevronRightIcon } from "../../../ChevronRight2.svg";

const { Panel } = Collapse;

class AppStandardDetailsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
    };
  }

  stateData() {
    return this.props.data;
  }

  stateFields() {
    return this.props.fields;
  }

  stateHeader() {
    return this.props.header;
  }

  componentDidMount() { }

  renderField(field) {
    if (field) {
      if (
        field?.value
      ) {
        return (
          <AppStandartContentFieldItem
            field={field}
            title={field?.caption || ''}
            value={
              field.value == "" || field.value == 0 || field.value == null || field.value == undefined
                ?
                // field.caption == "LBL_DEFERMENT_PERIOD" || field.caption == "LBL_DEFERMENT_PERIOD_B" ? "0" :
                "-"
                : field.value
            }
          />
        );
      }

    }
  }

  renderRow(item1, item2) {
    return (
      <Row>
        <Col className="col-lg-6 col-sm-12">
          {item1}
        </Col>
        <Col className="col-lg-6 col-sm-12">
          {item2}
        </Col>
      </Row>
    );
  }

  renderFieldsFromObject() {

    return (
      <>
        {this.stateFields() &&
          this.stateData() &&
          this.stateFields().map((field) => {
            if (field?.caption) {
              return <div className="details_sub_card_title">{field.caption}</div>
              // return <div className="details_sub_card_title">{LanguageBloc.getTextByCode(field.title)}</div>
            } else if (field?.divide) {
              return <div className="details_card_divide"></div>
            } else if (field?.fullWidth) {
              return (
                <div className={`ml-${field?.indent ? 5 : 4} mb-4`}>
                  {
                    this.stateData()[field.item1]?.value &&
                    <>
                      <div key={field.item1} className="app-content-field-tag" >
                        {this.stateData()[field.item1]?.caption || ''}
                      </div>
                      <div className="app-standard-content-field-content">
                        {this.stateData()[field.item1]?.value || ''}
                      </div>
                    </>
                  }
                </div>
              )
            } else if (field?.indent) {
              return (
                 <div key={field.item1} className="ml-3">
                  {this.renderRow(
                    field.item1
                      ? this.renderField(this.stateData()[field.item1])
                      : null,
                    field.item2
                      ? this.renderField(this.stateData()[field.item2])
                      : null
                  )}
                </div>
              )
            }
            else {
              return (
                <div key={field?.item1}>
                  {this.renderRow(
                    field.item1
                      ? this.renderField(this.stateData()[field.item1])
                      : null,
                    field.item2
                      ? this.renderField(this.stateData()[field.item2])
                      : null
                  )}
                </div>
              );
            }
          })}
      </>
    );
  }

  render() {
    console.log(this.props)
    return (
      <div className="collapse_container mt-3 d-flex align-items-center" style={{ wordWrap: 'break-word' }}>
        <Collapse
          className="p-1 d-flex align-items-center justify-items-center w-100"
          bordered={false}
          style={{
            backgroundColor: "white",
          }}
          defaultActiveKey={[0]}
          expandIcon={(isActive) =>
            isActive.isActive ? <ArrowDownIcon className="collapse_icon" />
              : <ChevronRightIcon className="collapse_icon" />
          }
        >
          <Panel
            key={1}
            header={this.stateHeader()}
            className="collapse_title w-100"
          >
            {this.stateData() ? this.renderFieldsFromObject() : null}
          </Panel>
        </Collapse>
      </div>

    );
  }
}

export default AppStandardDetailsCard;
